import { createContext, useContext } from 'react';
import { RootStore } from 'store/rootStore';
import { ProposalItemsStore } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import CartItemDelegate from 'store/modules/proposal/delegates/cartItemDelegate';
import { INITIAL_CART_ITEM, INITIAL_PORTFOLIO } from 'store/modules/proposal/types';
import ProductLineDelegate from 'store/modules/proposal/delegates/productLineDelegate';
import ProposalPageStore from './pageStore';

type ProposalPageDelegate = CartItemDelegate<ProposalPageStore>;

const proposalPageStore = new ProposalPageStore(new ProposalItemsStore(new RootStore()));

export const CartItemDelegateContext = createContext<ProposalPageDelegate>(
  new CartItemDelegate({
    pageStore: proposalPageStore,
    portfolioToCartItem: { portfolio: { ...INITIAL_PORTFOLIO }, cartItem: { ...INITIAL_CART_ITEM } },
    productLineDelegate: new ProductLineDelegate(new ProposalPageStore(new ProposalItemsStore(new RootStore())), null),
  }),
);

export function useCartItemDelegate(): ProposalPageDelegate {
  return useContext(CartItemDelegateContext);
}
